import Typography from '@mui/material/Typography';
import React from 'react';
// import { useTranslation } from 'react-i18next';
import '../assessments.css';
import cardio from '../../../../assets/cardio.png';
import mendurance from '../../../../assets/mendurance.png';
import mstrength from '../../../../assets/mstrength.png';
import sbalance1 from '../../../../assets/sbalance1.png';
import squats from '../../../../assets/squats.png';
import ninja from '../../../../assets/ninja.png';
import { ArcherContainer, ArcherElement } from 'react-archer';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import useMediaQuery from '@mui/material/useMediaQuery';
import PlaceAlternateFootIcon from '../../../../assets/BergBalance/placeAlternateFoot.png';
import SitToStandIcon from '../../../../assets/BergBalance/Sitting to Standing.png';
import StandOnOneFootIcon from '../../../../assets/BergBalance/Standing on One Foot.png';
import StandWithEyesClosedIcon from '../../../../assets/BergBalance/Standing eyes closed.png';
import StandWithFeetTogetherIcon from '../../../../assets/BergBalance/Standing with feet together.png';
import './bergsAssessment.css';

const TitleText = ({ children }) => {
  return (
    <Typography fontSize={14} sx={{ paddingLeft: 3 }}>
      {children}
    </Typography>
  );
};

export const AssessmentPathMini = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const matches = useMediaQuery('(max-width:900px)');
  const handleExerciseClick = (iteration) => {
    return () => {
      dispatch({
        type: 'SET-ITER',
        payload: {
          iteration: iteration,
          maxScore: 1,
          overviewRedirect: null,
          exerciseIds: null,
        },
      });
      dispatch({ type: 'RESET-INTRO' });
      navigate('/exercise/berg_balance_assessment_mini');
    };
  };
  return (
    <>
      {matches ? (
        <div className="assessment-cont">
          <div className="assessment-path">
            <ArcherContainer strokeColor="#000000" strokeDasharray="2,2,4,5,6">
              <div
                style={{
                  display: 'flex',
                  height: '20vh',
                  flexDirection: 'column',
                  justifyContent: 'space-between',
                }}
              >
                <div className="many_items_row">
                  <ArcherElement
                    id="root"
                    relations={[
                      {
                        targetId: 'sb2',
                        targetAnchor: 'top',
                        sourceAnchor: 'bottom',
                        style: {
                          endMarker: false,
                        },
                      },
                    ]}
                  >
                    <div
                      className="img_container_berg"
                      id="flexi"
                      onClick={handleExerciseClick(0)}
                    >
                      <div>Squats</div>
                      <img src={squats} />
                    </div>
                  </ArcherElement>
                  <ArcherElement id="mstren">
                    <div
                      className="img_container_berg"
                      onClick={handleExerciseClick(2)}
                    >
                      <div>Muscular Strength</div>
                      <img src={mstrength} />
                    </div>
                  </ArcherElement>
                </div>
                <div
                  className="many_items_row"
                  style={{ justifyContent: 'center' }}
                >
                  <ArcherElement
                    id="sb2"
                    relations={[
                      {
                        targetId: 'cdio',
                        targetAnchor: 'bottom',
                        sourceAnchor: 'top',
                      },
                    ]}
                  >
                    <div
                      className="img_container_berg"
                      onClick={handleExerciseClick(4)}
                    >
                      <div>Static Balance 2</div>
                      <img src={ninja} />
                    </div>
                  </ArcherElement>
                </div>
              </div>
            </ArcherContainer>
          </div>
          <div className="assessment-path">
            <ArcherContainer strokeColor="#000000" strokeDasharray="2,2,4,5,6">
              <div
                style={{
                  display: 'flex',
                  height: '50vh',
                  flexDirection: 'column',
                  justifyContent: 'space-between',
                }}
              >
                <div className="many_items_row">
                  <ArcherElement
                    id="mend"
                    relations={[
                      {
                        targetId: 'cdio',
                        targetAnchor: 'top',
                        sourceAnchor: 'bottom',
                        style: {
                          endMarker: false,
                        },
                      },
                    ]}
                  >
                    <div
                      className="img_container_berg"
                      onClick={handleExerciseClick(1)}
                    >
                      <div>Muscular Endurance</div>
                      <img src={mendurance} />
                    </div>
                  </ArcherElement>
                  <ArcherElement id="sb1">
                    <div
                      className="img_container_berg"
                      onClick={handleExerciseClick(3)}
                    >
                      <div>Static Balance 1</div>
                      <img src={sbalance1} />
                    </div>
                  </ArcherElement>
                </div>
                <div
                  className="many_items_row"
                  style={{ justifyContent: 'center' }}
                >
                  <ArcherElement
                    id="cdio"
                    relations={[
                      {
                        targetId: 'sb2',
                        targetAnchor: 'bottom',
                        sourceAnchor: 'top',
                        style: {
                          endMarker: false,
                        },
                      },
                    ]}
                  >
                    <div
                      className="img_container_berg"
                      onClick={handleExerciseClick(5)}
                    >
                      <div>Cardio Vascular</div>
                      <img src={cardio} />
                    </div>
                  </ArcherElement>
                </div>
              </div>
            </ArcherContainer>
          </div>
        </div>
      ) : (
        <div
          className="top-left article"
          style={{
            padding: '5% 4px',
            height: '75vh',
            width: 'auto',
            marginTop: '1em',
            marginBottom: 4,
          }}
        >
          <ArcherContainer strokeColor="#000000" strokeDasharray="2,2,4,5,6">
            <div
              style={{
                display: 'flex',
                height: '60vh',
                flexDirection: 'column',
                justifyContent: 'space-between',
              }}
            >
              <div className="many_items_row">
                <ArcherElement
                  id="root"
                  relations={[
                    {
                      targetId: 'standingwithfeettogether',
                      targetAnchor: 'top',
                      sourceAnchor: 'bottom',
                      style: {
                        endMarker: false,
                      },
                    },
                  ]}
                >
                  <div
                    className="img_container_berg"
                    id="flexi"
                    onClick={handleExerciseClick(0)}
                  >
                    <TitleText>Sit to Stand</TitleText>
                    <img src={SitToStandIcon} />
                  </div>
                </ArcherElement>
                <ArcherElement
                  id="standingwitheyesclosed"
                  relations={[
                    {
                      targetId: 'placingalternatefootonstep',
                      targetAnchor: 'top',
                      sourceAnchor: 'bottom',
                      style: {
                        endMarker: false,
                      },
                    },
                  ]}
                >
                  <div
                    className="img_container_berg"
                    id="flexi"
                    onClick={handleExerciseClick(2)}
                  >
                    <img src={StandWithEyesClosedIcon} />
                    <TitleText>Stand with Eyes Closed</TitleText>
                  </div>
                </ArcherElement>

                <ArcherElement id="standingononefoot">
                  <div
                    className="img_container_berg"
                    onClick={handleExerciseClick(4)}
                  >
                    <img src={StandOnOneFootIcon} />
                    <TitleText>Stand on One Foot</TitleText>
                  </div>
                </ArcherElement>
              </div>
              <div
                className="many_items_row"
                style={{ justifyContent: 'center', width: '100%' }}
              >
                <ArcherElement
                  id="standingwithfeettogether"
                  relations={[
                    {
                      targetId: 'standingwitheyesclosed',
                      targetAnchor: 'bottom',
                      sourceAnchor: 'top',
                      style: {
                        endMarker: false,
                      },
                    },
                  ]}
                >
                  <div
                    className="img_container_berg"
                    onClick={handleExerciseClick(1)}
                  >
                    <img src={StandWithFeetTogetherIcon} />
                    <TitleText>Stand with Feet Together</TitleText>
                  </div>
                </ArcherElement>
                <ArcherElement
                  id="placingalternatefootonstep"
                  relations={[
                    {
                      targetId: 'standingononefoot',
                      targetAnchor: 'bottom',
                      sourceAnchor: 'top',
                      style: {
                        endMarker: false,
                      },
                    },
                  ]}
                >
                  <div
                    className="img_container_berg"
                    onClick={handleExerciseClick(3)}
                  >
                    <img src={PlaceAlternateFootIcon} />
                    <TitleText>Place Alternate Foot on Step</TitleText>
                  </div>
                </ArcherElement>
              </div>
            </div>
          </ArcherContainer>
        </div>
      )}
    </>
  );
};
